import {Grid, Typography, useTheme} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import {useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {FormAlertModel} from "../../../api/types/alert";
import Radio from "@mui/material/Radio";
import {FormAutocomplete} from "../../../common/form-fields";
import FormTimePicker from "../../../common/form-fields/FormTimePicker";

type Props = {
    readonly: boolean;
}

const MonthlyScheduler = ({readonly}: Props) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    const daysOfTheWeek: number[] = Array.from(Array(28).keys()).map((el: number) => el + 1);

    //USE FORM CONTEXT
    const {register, watch, setValue, getValues, resetField} =
        useFormContext<FormAlertModel>();

    // Use Theme
    const theme = useTheme();

    return (
        <>
            <Grid container spacing={2} p={2} alignItems="start">
                <Typography variant="h6" width={"100%"} pl={2} mt={4}>
                    {t("pricing:alert.labels.monthlySchedule")}
                </Typography>
                <Grid item xs={12}>
                    <FormControl sx={{width: "100%"}}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="crons.radioType"
                            color={"accent"}
                            defaultValue={getValues().crons.radioType}
                            onChange={(e: any) => {
                                resetField("crons.monthlyDays");
                                setValue("crons.radioType", e.target.value);
                            }}
                        >
                            <Grid
                                container
                                spacing={2}
                                p={2}
                                alignItems="center">
                                <Grid item xs={12} md={3}>
                                    <FormControlLabel
                                        value={t("pricing:alert.labels.every")}
                                        sx={{
                                            width: "100%",
                                            "& .MuiFormControlLabel-label": {
                                                width: "100%"
                                            }
                                        }}
                                        control={
                                            <Radio
                                                disabled={readonly}
                                                sx={{
                                                    color: theme.palette.accent
                                                        .main,
                                                    "&.Mui-checked": {
                                                        color: theme.palette
                                                            .accent.main
                                                    },
                                                    padding: 0,
                                                    marginRight: "9px"
                                                }}
                                            />
                                        }
                                        label={
                                            <FormAutocomplete
                                                sx={{width: "100%"}}
                                                {...register("crons.monthlyDays")}
                                                label={t("pricing:alert.labels.every")}
                                                options={daysOfTheWeek}
                                                helperText={t("pricing:alert.labels.everyDayOfTheMonth")}
                                                disabled={readonly || watch("crons.radioType") === t("pricing:alert.labels.lastDayOfTheMonth")}
                                                isOptionEqualToValue={(option, value) => option === value}
                                            />
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FormControlLabel
                                        value={t(
                                            "pricing:alert.labels.lastDayOfTheMonth"
                                        )}
                                        control={
                                            <Radio
                                                disabled={readonly}
                                                sx={{
                                                    color: theme.palette.accent
                                                        .main,
                                                    "&.Mui-checked": {
                                                        color: theme.palette
                                                            .accent.main
                                                    },
                                                    padding: 0,
                                                    marginRight: "9px"
                                                }}
                                            />
                                        }
                                        label={t(
                                            "pricing:alert.labels.lastDayOfTheMonth"
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </RadioGroup>
                    </FormControl>
                </Grid>
                {/* START TIME */}
                <Grid item xs={12} md={3}>
                    <FormTimePicker
                        {...register("crons.startTime")}
                        label="START TIME*"
                        readOnly={readonly}
                    />
                </Grid>
                {/* ADD TIME */}
                <Grid item xs={12} md={3}>
                    <FormTimePicker
                        {...register("crons.addTime")}
                        label="ADD TIME"
                        readOnly={readonly || !watch("crons.startTime")}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default MonthlyScheduler;
